import { FaArchive, FaWrench } from "react-icons/fa"
import { GrFormCheckmark } from "react-icons/gr"
import { FiAlertTriangle, FiArchive } from "react-icons/fi"
import { BsArrowDownSquare } from "react-icons/bs"
import { BikeState } from "../types/bike"
import { isSupervisor } from "../helpers/role"
import { Role } from "../types/user"
import { MapBikeEntity } from "../hooks/queries/useGetMapBikesQuery"

const available = { label: "Make available", value: "declare_available", icon: GrFormCheckmark }
const cancelRent = { label: "Cancel reservation", value: "return", icon: GrFormCheckmark }
const maintenance = { value: "put_in_maintenance", icon: FaWrench, label: "Put in maintenance" }
const forceMaintenance = { value: "force_put_in_maintenance", icon: FaWrench, label: "Force in maintenance" }
const lost = { label: "Declare lost", icon: FiAlertTriangle, value: "declare_lost" }
const retire = { label: "Retire", icon: FiArchive, value: "retire" }
const unretire = { value: "force_put_in_maintenance", icon: FaArchive, label: "Unretire" }
const deployed = { value: "deploy", icon: BsArrowDownSquare, label: "Set as deployed" }

export function getBikeStateOptions(
  currentState: BikeState,
  roles?: Role[],
  adminFeatures?: boolean,
  assetDeployedState?: boolean,
) {
  let options
  switch (currentState) {
    case "available":
      options = [maintenance, lost]
      if (assetDeployedState) options.push(deployed)
      break
    case "in_maintenance":
      options = isSupervisor(roles) && adminFeatures ? [available, lost, retire] : [available, lost]
      break
    case "rented":
      options = [cancelRent, forceMaintenance]
      break
    case "lost":
      options = [available, maintenance]
      break
    case "unrecoverable":
      options = [available]
      break
    case "retired":
      options = isSupervisor(roles) && adminFeatures ? [unretire] : []
      break
    case "deployed":
      options = [available, lost]
      break
    default:
      options = [available, lost]
  }
  //if (roles?.includes("supervisor") && currentState !== "retired") options.push(retire)
  return options
}

export const BIKE_STATES: { label: string; value: BikeState; color: string }[] = [
  { label: "Available", value: "available", color: "blue" },
  { label: "Rented", value: "rented", color: "green" },
  { label: "In maintenance", value: "in_maintenance", color: "gray" },
  { label: "Unrecoverable", value: "unrecoverable", color: "orange" },
  { label: "Lost", value: "lost", color: "red" },
  { label: "Retired", value: "retired", color: "purple" },
]

export const getBikeStates = (assetDeployedState?: boolean) => {
  return assetDeployedState
    ? BIKE_STATES.concat([{ label: "Deployed", value: "deployed", color: "brown" }])
    : BIKE_STATES
}

export const BIKE_ACTIVE_COLOR = "#ccba00"

export const BIKE_MARKER_COLORS: { [key: string]: string } = {
  available: "blue",
  rented: "green",
  in_maintenance: "gray",
  unrecoverable: "orange",
  lost: "red",
  unknown: "gray",
  undefined: "gray",
  retired: "purple",
  active: "yellow",
  deployed: "brown",
}

export const BIKE_MARKER_TEXT_COLORS: { [key: string]: string } = {
  available: "blue.500",
  rented: "green.800",
  in_maintenance: "gray.800",
  retired: "purple.500",
  unrecoverable: "orange.800",
  lost: "red.800",
  unknown: "gray.800",
  deployed: "brown.600",
}

export const bikeIsGoogleParkingWindmaster = (bike: MapBikeEntity) => {
  if (bike.model && bike.model.includes("d5c4befc-49d7-4c8b-93ec-bf33b073ea3f")) return true
  return false
}
